import { Omit } from '@40seas/entities/common';
import { SegmentEntityFieldsArray } from '@40seas/models';
import { CreditSafeReport } from './credit-safe.report.entity';

export class CreateCreditSafeReportDto extends Omit(CreditSafeReport, SegmentEntityFieldsArray) {}
